import GameSpin from './gamespin';

export default GameSpin;
